import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { Login } from './pages/Login.js';
import { Dashboard } from './pages/Dashboard.js';
import { Devices } from './pages/Devices.js';
import { DeviceDetail } from './pages/DeviceDetail.js';
import { Services } from './pages/Services.js';
import { ServiceDetail } from './pages/ServiceDetail.js';
import { Users } from './pages/Users.js';
import { Firmware } from './pages/Firmware.js';
import { Members } from './pages/Members.js';
import { Reports } from './pages/Reports.js';
import { Warranty } from './pages/Warranty.js';
import { AppRoles } from './pages/AppRoles.js';
import { ProductionTesters } from './pages/ProductionTesters.js';
import { WarrantySettings } from './pages/WarrantySettings.js';
import { Faq } from './pages/Faq.js';
import { ContentDocuments } from './pages/ContentDocuments.js';
import { AppManagement } from './pages/AppManagement.js';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/devices/:id" element={<DeviceDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/members" element={<Members />} />
          <Route path="/users" element={<Users />} />
          <Route path="/firmware" element={<Firmware />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/app-roles" element={<AppRoles />} />
          <Route path="/production-testers" element={<ProductionTesters />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/warranty-settings" element={<WarrantySettings />} />
          <Route path="/faq" element={<Faq />} />
<Route path="/content-documents" element={<ContentDocuments />} />
          <Route path="/app-management" element={<AppManagement />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
